import { ExtractHotels, InfoLanguage, LinkHotelsParams, NimbuxHotel, PatchHotelParams } from "@bandido/shared/interfaces";
import { client } from "../common/services";
import { useMutation, UseMutationOptions } from "react-query";
import { AxiosResponse } from "axios";



const extractoHotels = async ( params: ExtractHotels) =>
  client.post<boolean>(`content-extractor/extract-hotels`, params);

export const useExtractHotels = (
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<boolean, any>,
          unknown,
          ExtractHotels,
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => extractoHotels(data), options);



const linkHotels = async ( params: LinkHotelsParams) =>
  client.post<boolean>(`content-extractor/vendor-hotel/${params.vendorHotelId}/link`, params);

export const useLinkHotels = (
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<boolean, any>,
          unknown,
          LinkHotelsParams,
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => linkHotels(data), options);

const patchHotel = async (params: PatchHotelParams) =>
  client.patch<NimbuxHotel>(`content-extractor/nimbux-hotel/${params.id}`, params);

export const usePatchHotel = (
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<NimbuxHotel, any>,
          unknown,
          PatchHotelParams,
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => patchHotel(data), options);


const generateTranslations = async (params: { text: string }) =>
  client.post<{ instructions: Record<InfoLanguage, string> }>(`content-extractor/ia/translate`, params);

export const useGenerateTranslations = (
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<{ instructions: Record<InfoLanguage, string> }, any>,
          unknown,
          { text: string },
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => generateTranslations(data), options);

